import { render, staticRenderFns } from "./settleDetails.vue?vue&type=template&id=4bbddbbc&scoped=true"
import script from "./settleDetails.vue?vue&type=script&lang=js"
export * from "./settleDetails.vue?vue&type=script&lang=js"
import style0 from "./settleDetails.vue?vue&type=style&index=0&id=4bbddbbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbddbbc",
  null
  
)

export default component.exports